export default __webpack_public_path__ + "static/media/footerlogo.17d5e604.svg";